import { baseAPI } from 'api/base';
import isFetchBaseQueryError from 'api/baseError';

baseAPI.enhanceEndpoints({
	addTagTypes: ['Login', 'VerifyByOtp', 'Logout']
});

export const authAPI = baseAPI.injectEndpoints({
	endpoints: builder => ({
		login: builder.mutation({
			query: credentials => ({
				url: 'auth/bank/login',
				method: 'POST',
				body: credentials,
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['Login']
		}),
		changePassword: builder.mutation({
			query: credentials => ({
				url: 'auth/change-password',
				method: 'POST',
				body: credentials,
				validateStatus: isFetchBaseQueryError
			})
		}),
		resendEmailOTP: builder.mutation({
			query: () => ({
				url: 'auth/verify/resend',
				method: 'GET',
				validateStatus: isFetchBaseQueryError
			})
		}),
		verifyByOtp: builder.mutation({
			query: credentials => ({
				url: 'auth/verify/store',
				method: 'POST',
				body: credentials,
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['VerifyByOtp']
		}),
		logout: builder.mutation({
			query: credentials => ({
				url: 'auth/logout',
				method: 'POST',
				body: credentials,
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['Logout']
		})
	})
});

export const {
	useLoginMutation,
	useVerifyByOtpMutation,
	useResendEmailOTPMutation,
	useChangePasswordMutation,
	useLogoutMutation
} = authAPI;
